import * as actionTypes from './types/countries';
import { createAction } from '@/utillity/createAction';

export const getCountries = () => createAction(actionTypes.GET_COUNTRIES.INIT);

export default getCountries;
